module.exports = [
	{
		"fund_family_label": "Vanguard",
		"net_assets": 7749390759689,
		"asset_rank": 1,
		"num_funds": 116,
		"sri": 6,
		"gef_num_funds": 114,
		"gef_score_norm": 53.7091095495392,
		"gef_score": 52.00102021234577,
		"gef_score_rank": 4,
		"dei_num_funds": 94,
		"dei_score_norm": 34.04253897556179,
		"dei_score": 28.19708414126444,
		"dei_score_rank": 5,
		"rji_num_funds": 94,
		"rji_score_norm": 24.628067925380655,
		"rji_score": 20.992953021213296,
		"rji_score_rank": 5,
		"hrc_num_funds": 76,
		"hrc_score_norm": 88.24183435618414,
		"hrc_score": 84.89041745017802,
		"hrc_score_rank": 4,
		"name": "Vanguard",
		"fund_family_name": "Vanguard",
		"label": "Vanguard"
	},
	{
		"fund_family_label": "Fidelity Investments",
		"net_assets": 3294414295197,
		"asset_rank": 2,
		"num_funds": 363,
		"sri": 31,
		"gef_num_funds": 343,
		"gef_score_norm": 53.59579844365614,
		"gef_score": 52.562950113872866,
		"gef_score_rank": 5,
		"dei_num_funds": 274,
		"dei_score_norm": 34.6279559967779,
		"dei_score": 29.673849350133658,
		"dei_score_rank": 3,
		"rji_num_funds": 274,
		"rji_score_norm": 24.666936106925853,
		"rji_score": 21.94581488288947,
		"rji_score_rank": 4,
		"hrc_num_funds": 238,
		"hrc_score_norm": 89.58467301788092,
		"hrc_score": 87.15514549986723,
		"hrc_score_rank": 2,
		"name": "Fidelity Investments",
		"fund_family_name": "Fidelity Investments",
		"label": "Fidelity Investments"
	},
	{
		"fund_family_label": "BlackRock/iShares",
		"net_assets": 2793687951527,
		"asset_rank": 3,
		"num_funds": 354,
		"sri": 46,
		"gef_num_funds": 302,
		"gef_score_norm": 52.87539618773493,
		"gef_score": 52.70622941572067,
		"gef_score_rank": 8,
		"dei_num_funds": 223,
		"dei_score_norm": 31.881894393802188,
		"dei_score": 29.241017149858607,
		"dei_score_rank": 8,
		"rji_num_funds": 223,
		"rji_score_norm": 23.167134252568253,
		"rji_score": 20.86164003387112,
		"rji_score_rank": 9,
		"hrc_num_funds": 182,
		"hrc_score_norm": 86.78271444460582,
		"hrc_score": 85.7056229284874,
		"hrc_score_rank": 8,
		"name": "BlackRock/iShares",
		"fund_family_name": "BlackRock/iShares",
		"label": "BlackRock/iShares"
	},
	{
		"fund_family_label": "American Funds/Capital Group",
		"net_assets": 2380005169569,
		"asset_rank": 4,
		"num_funds": 52,
		"sri": 0,
		"gef_num_funds": 50,
		"gef_score_norm": 55.130721913538245,
		"gef_score": 55.13960053102272,
		"gef_score_rank": 1,
		"dei_num_funds": 42,
		"dei_score_norm": 36.399609660075306,
		"dei_score": 35.44139751671872,
		"dei_score_rank": 1,
		"rji_num_funds": 42,
		"rji_score_norm": 25.213126047693653,
		"rji_score": 24.868100421936024,
		"rji_score_rank": 2,
		"hrc_num_funds": 40,
		"hrc_score_norm": 89.60759227270542,
		"hrc_score": 89.34462405347904,
		"hrc_score_rank": 1,
		"name": "American Funds/Capital Group",
		"fund_family_name": "American Funds/Capital Group",
		"label": "American Funds/Capital Group"
	},
	{
		"fund_family_label": "State Street",
		"net_assets": 1313917741854,
		"asset_rank": 5,
		"num_funds": 97,
		"sri": 6,
		"gef_num_funds": 88,
		"gef_score_norm": 54.049329853148926,
		"gef_score": 50.222592804857754,
		"gef_score_rank": 2,
		"dei_num_funds": 77,
		"dei_score_norm": 35.99951675392681,
		"dei_score": 24.46296109790834,
		"dei_score_rank": 2,
		"rji_num_funds": 77,
		"rji_score_norm": 25.262946592700768,
		"rji_score": 17.4423391506097,
		"rji_score_rank": 1,
		"hrc_num_funds": 55,
		"hrc_score_norm": 87.67993513651157,
		"hrc_score": 79.15030253085708,
		"hrc_score_rank": 6,
		"name": "State Street",
		"fund_family_name": "State Street",
		"label": "State Street"
	},
	{
		"fund_family_label": "Invesco",
		"net_assets": 822202573714,
		"asset_rank": 6,
		"num_funds": 206,
		"sri": 14,
		"gef_num_funds": 191,
		"gef_score_norm": 52.17457266603146,
		"gef_score": 49.7708896405754,
		"gef_score_rank": 9,
		"dei_num_funds": 170,
		"dei_score_norm": 34.086054752161054,
		"dei_score": 23.491589398961953,
		"dei_score_rank": 4,
		"rji_num_funds": 170,
		"rji_score_norm": 24.867792100335304,
		"rji_score": 17.74756481069387,
		"rji_score_rank": 3,
		"hrc_num_funds": 124,
		"hrc_score_norm": 86.75037368226367,
		"hrc_score": 80.12357892673398,
		"hrc_score_rank": 9,
		"name": "Invesco",
		"fund_family_name": "Invesco",
		"label": "Invesco"
	},
	{
		"fund_family_label": "T. Rowe Price",
		"net_assets": 746002321796,
		"asset_rank": 7,
		"num_funds": 105,
		"sri": 1,
		"gef_num_funds": 96,
		"gef_score_norm": 53.089166337377385,
		"gef_score": 52.353293261472324,
		"gef_score_rank": 6,
		"dei_num_funds": 85,
		"dei_score_norm": 32.670699538459644,
		"dei_score": 29.98714999908995,
		"dei_score_rank": 7,
		"rji_num_funds": 85,
		"rji_score_norm": 24.132580146551494,
		"rji_score": 21.961943748997854,
		"rji_score_rank": 6,
		"hrc_num_funds": 69,
		"hrc_score_norm": 88.03986989188031,
		"hrc_score": 86.83215648402697,
		"hrc_score_rank": 5,
		"name": "T. Rowe Price",
		"fund_family_name": "T. Rowe Price",
		"label": "T. Rowe Price"
	},
	{
		"fund_family_label": "Thrift Savings Plan",
		"net_assets": 684600000006,
		"asset_rank": 8,
		"num_funds": 11,
		"sri": 0,
		"gef_num_funds": 11,
		"gef_score_norm": 53.048522152528996,
		"gef_score": 53.497589346993216,
		"gef_score_rank": 7,
		"dei_num_funds": 10,
		"dei_score_norm": 31.82419680241598,
		"dei_score": 30.5590986504322,
		"dei_score_rank": 9,
		"rji_num_funds": 10,
		"rji_score_norm": 23.22897685751376,
		"rji_score": 22.528551713609982,
		"rji_score_rank": 8,
		"hrc_num_funds": 8,
		"hrc_score_norm": 89.48175464453207,
		"hrc_score": 88.59471030860297,
		"hrc_score_rank": 3,
		"name": "Thrift Savings Plan",
		"fund_family_name": "Thrift Savings Plan",
		"label": "Thrift Savings Plan"
	},
	{
		"fund_family_label": "Schwab Funds",
		"net_assets": 595832992561,
		"asset_rank": 9,
		"num_funds": 62,
		"sri": 1,
		"gef_num_funds": 59,
		"gef_score_norm": 53.73730546071103,
		"gef_score": 52.65842620475236,
		"gef_score_rank": 3,
		"dei_num_funds": 49,
		"dei_score_norm": 33.077733368620386,
		"dei_score": 29.592260385002216,
		"dei_score_rank": 6,
		"rji_num_funds": 49,
		"rji_score_norm": 23.53651244089782,
		"rji_score": 21.84832489929073,
		"rji_score_rank": 7,
		"hrc_num_funds": 39,
		"hrc_score_norm": 87.50800675507632,
		"hrc_score": 87.75631116197621,
		"hrc_score_rank": 7,
		"name": "Schwab Funds",
		"fund_family_name": "Schwab Funds",
		"label": "Schwab Funds"
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/data/FamilyFunds.json
// module id = 928
// module chunks = 0